module.exports = {
  "country": "UK",
  "artist": "Sam Ryder",
  "song": "Space Man",
  "year": "2022",
  "place": "2",
  "spotify": "7tmBKObyRvblH21o8LuhPL"
};